(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("settingsLocation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/location/settingsLocationView.html",
            controller: ["messageService", "tenantResource", "$translate", "globalizationService", "_", SettingsLocationCtrl],
            controllerAs: "vm"
        };
        function SettingsLocationCtrl(messageService, tenantResource, $translate, globalizationService, _) {
            var vm = this;
            vm.showErrors = false;
            tenantResource.getLocation(function (data) {
                vm.model = data;
                vm.countryList = data.allCountries;
                vm.updateProvinceList(true);
            }, function (error) {
                messageService.error(error);
            });
            vm.updateProvinceList = function (firstLoad) {
                var countryObj = _.find(vm.countryList, { id: vm.model.billingAddress.countryId });
                if (countryObj) {
                    globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                        vm.stateProvinceLabel = result.stateProvinceLabel;
                        vm.postalZipLabel = result.postalZipLabel;
                        vm.postalZipRegex = new RegExp(result.postalZipRegex);
                        vm.postalZipPattern = result.postalZipPattern;
                        vm.postalZipMask = result.postalZipMask;
                    });
                    vm.provinceList = countryObj.provinces;
                }
                if (!firstLoad || vm.model.stateProvinceId === 0) {
                    vm.model.stateProvinceId = null;
                }
            };
            vm.translateName = function (name, isCountry) {
                if (isCountry)
                    return $translate.instant("common.country." + name.replace(/\s+/g, ''));
                return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ''));
            };
            vm.save = function () {
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantResource.updateLocation(vm.model.billingAddress, function () {
                        messageService.success("settings.general.location.saved");
                        vm.saving = false;
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
